import styled from 'styled-components';
import { colorGetter } from '../../../../utils';
import { Flex } from '../../../Flex';
export var Wrapper = styled(Flex).withConfig({
  displayName: "styled__Wrapper",
  componentId: "sc-19n3wu4-0"
})(["pointer-events:", ";"], function (_ref) {
  var disabled = _ref.disabled;
  return disabled ? 'none' : 'auto';
});
export var Bar = styled.div.attrs(function (_ref2) {
  var theme = _ref2.theme,
      value = _ref2.value,
      fillerColor = _ref2.fillerColor;
  return {
    style: {
      backgroundImage: "linear-gradient(90deg, \n        " + colorGetter(theme)(fillerColor) + " " + value + "%, " + theme.colors.grey.base + " " + value + "%)"
    }
  };
}).withConfig({
  displayName: "styled__Bar",
  componentId: "sc-19n3wu4-1"
})(["width:100%;height:4px;border-radius:8px;position:relative;overflow:hidden;"]);